import Store from 'types/Store/CheckOutChargesStore';

export const getCurrentFolioNumber = (state: Store) =>
  state.checkOutCharges.currentFolioNumber;
